import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgDeniedIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M54 31.6C54 43.971 43.971 54 31.6 54a22.32 22.32 0 0 1-14.897-5.671q.136-.08.257-.192l32-30.117q.138-.132.233-.287A22.3 22.3 0 0 1 54 31.6M14.793 46.408a1.4 1.4 0 0 1 .248-.31l32-30.117q.168-.159.368-.25A22.33 22.33 0 0 0 31.6 9.2C19.229 9.2 9.2 19.229 9.2 31.6c0 5.677 2.112 10.86 5.593 14.808M31.6 57.2c14.139 0 25.6-11.461 25.6-25.6S45.739 6 31.6 6 6 17.461 6 31.6s11.461 25.6 25.6 25.6"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgDeniedIcon
